import React from 'react'
import { Printer } from 'lucide-react'

// ButtonWithIcon pinta `svg { fill }`; el estilo en línea lo anula para que el icono quede sólo con trazo.
const icon = ({ style, ...props }) => (
  <Printer size={18} style={{ fill: 'none', ...style }} {...props} />
)

export default icon
